import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ApolloClient, InMemoryCache, ApolloProvider } from '@apollo/client';
import branch from 'branch-sdk';
import amplitude from 'amplitude-js';
import ReactGA from 'react-ga4';

import { isDev } from 'utils/Environment';
import { DebugProvider } from 'utils/DebugContext';

const client = new ApolloClient({
  uri: `https://${isDev ? 'qa' : 'prod'}.takemeoutofoffice.com/data`,
  cache: new InMemoryCache(),
});

branch.init('key_live_mo3AyWkf8UHfnymyspczqgdbEBcfAC8s', (err) => {
  if (err) {
    console.log('Error initializing Branch SDK:', err);
  } else {
    isDev && console.log('Branch SDK initialized');
  }
});

amplitude.getInstance().init('5d4255b6ef7447efc19528a5a191bf19');
ReactGA.initialize('G-JVRG3W1BD5');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <DebugProvider>
    <ApolloProvider client={client}>
      <App />
    </ApolloProvider>
  </DebugProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
